module.exports = __webpack_public_path__ + "static/aesthetik-logo-01-35cee35e8debcb2f8f988881865befd9.jpg";